import { defineComponent as _defineComponent } from 'vue'
import { GeneratorChooserDlg } from '@/modules/shared/components/choosers';
import Utils from '@/assets/js/utils/Utils';
import NotificationService from '@/assets/js/services/NotificationService';
import GenericTable from '@/modules/shared/components/table/GenericTable.vue';
import { TableColumn } from '@/modules/shared/components/table/types';
import { Port } from '@/modules/shared/Port';
import { Events } from '@/modules/shared';
import { computed, onMounted, ref, watch } from 'vue';
import Formatter from '@/assets/js/utils/Formatter';
import { i18n } from '@/plugins/i18n';

interface GeneratorTableEntry {
    key: string;
    name: string;
    parkName: string;
    installationDate?: number;
    power?: number;
    hubHeight?: number;
    serialNumber?: string;
    zipCode?: string;
    type: string;
    model: string;
}

type Props = {
    portfolioKey: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PortfolioGenerators',
  props: {
    portfolioKey: null
  },
  setup(__props: any) {

const props = __props as {
    portfolioKey: string;
};



const searchText = ref<string>('');
const showGeneratorChooseDialog = ref<boolean>(false);
const selectedGenerators = ref<GeneratorTableEntry[]>([]);
const generators = ref<GeneratorTableEntry[]>([]);
const isLoading = ref<boolean>(false);

const tableColumns = computed<TableColumn[]>(() => [
    // { title: 'generators.type', field: 'type', class: 'w-16 hidden lg:table-cell' },
    { title: 'generators.model', field: 'name', class: 'w-full xs:w-3/4 sm:w-2/5 xl:w-1/5' },
    { title: 'generators.park', field: 'parkName', class: 'hidden w-2/5 sm:table-cell lg:w-1/5 ' },
    { title: 'generators.installation-date', field: 'installationDate', class: 'hidden w-1/5 lg:table-cell', render: (value) => Formatter.formatDate(value), placeholder: '?' },
    { title: 'generators.power', field: 'power', placeholder: '? kw', render: (value) => Formatter.formatPower(value), class: 'hidden w-1/4 xs:table-cell sm:w-1/5' },
    { title: 'generators.hub-height', field: 'hubHeight', placeholder: i18n.t('unknown').toString(), render: (value: string) => `${value} m`, class: 'hidden w-1/5 xl:table-cell' },
    { title: 'generators.serial-number', field: 'serialNumber', placeholder: i18n.t('unknown').toString(), class: 'hidden w-1/5 xl:table-cell' },
]);

const sortedGenerators = computed<GeneratorTableEntry[]>(() => [...generators.value]
    .sort((a, b) => (a.parkName || '').localeCompare(b.parkName || '')
            || (a.name || '').localeCompare(b.name || '')));

const filteredGenerators = computed<GeneratorTableEntry[]>(() => sortedGenerators.value
    .filter((generator: GeneratorTableEntry) => Utils.anyValueMatchesSearchTerm(generator, searchText.value.trim().toLowerCase())));

function updateSelected(selected: GeneratorTableEntry[]) {
    selectedGenerators.value = selected;
}

async function fetchGenerators(): Promise<void> {
    isLoading.value = true;
    const portfolio = await Port.portfolios.getPortfolioByKey(props.portfolioKey);
    const generatorsByKeys = await Port.generators.getGeneratorsByKeys(portfolio?.generatorKeys || []);
    generators.value = await Promise.all(generatorsByKeys.map(async (gen) => {
        const park = await Port.parks.getParkByKey(gen.parkKey!);
        return {
            key: gen.key,
            name: gen.name,
            parkName: park?.name || '',
            hubHeight: gen.hubHeight,
            installationDate: gen.installationDate,
            power: gen.power,
            serialNumber: gen.serialNumber,
            type: 'wind',
            zipCode: park?.zipCode,
            model: gen.model || '',
        };
    }));
    isLoading.value = false;
}

async function removeGenerators() {
    try {
        const keys: string[] = selectedGenerators.value.map((generator: GeneratorTableEntry) => generator.key);
        await Port.portfolios.removeGeneratorsFromPortfolio(props.portfolioKey, keys);
    } catch (e: any) {
        switch (e.status) {
            case 404: NotificationService.error('Portfolio nicht gefunden', e); break;
            case 401: NotificationService.error('Keine Berechtigung', e); break;
            case 500: NotificationService.error('Unerwarteter Serverfehler', e); break;
            default: NotificationService.error('Unbekannter Fehler', e); break;
        }
    }
}

async function addGenerators(generatorKeys: string[]) {
    showGeneratorChooseDialog.value = false;
    try {
        await Port.portfolios.addGeneratorsToPortfolio(props.portfolioKey, generatorKeys);
    } catch (e: any) {
        switch (e.status) {
            case 404: NotificationService.error('Portfolio nicht gefunden', e); break;
            case 401: NotificationService.error('Keine Berechtigung', e); break;
            case 500: NotificationService.error('Unerwarteter Serverfehler', e); break;
            default: NotificationService.error('Unbekannter Fehler', e); break;
        }
    }
}

watch(() => props.portfolioKey, fetchGenerators);

onMounted(async () => {
    await fetchGenerators();
    Events.instance.on('generators--changed', fetchGenerators);
    Events.instance.on('portfolios--changed', fetchGenerators);
});

return { __sfc: true,props, searchText, showGeneratorChooseDialog, selectedGenerators, generators, isLoading, tableColumns, sortedGenerators, filteredGenerators, updateSelected, fetchGenerators, removeGenerators, addGenerators, GeneratorChooserDlg, GenericTable }
}

})